module.exports = __webpack_public_path__ + "static/visionar_augmented_reality_ar-in-business__fin_792-352-d537e0c11ec76066d93fe24a20c4a500.jpg";